import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      // Keep production clean while still making development failures visible.
      console.error("Route render failed:", error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="container py-5" role="alert">
          <div className="alert alert-danger">
            <h1 className="h4">Something went wrong</h1>
            <p className="mb-3">
              We could not render this page. Please refresh and try again.
            </p>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Retry
            </button>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
